import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";
import { Task, TaskAction } from "../taskbook.types";
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { TaskbookService } from "../taskbook.service";

@Component({
    selector: 'task-actions',
    templateUrl: './task-actions.component.html',
    styleUrls: ['./task-actions.component.scss', '../task/task.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        TranslateModule,
        MatButtonModule,
        MatMenuModule
    ]
})
export class TaskActionsComponent implements OnChanges{

    taskActions: TaskAction[]

    @Input() context: 'taskbook' | 'task-success-dialog';
    @Input() task: Task;

    @Output() onAction = new EventEmitter<{ task: Task, action: TaskAction }>()

    constructor(
        private taskbookService: TaskbookService
    ){}

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.task){
            this.taskActions = this.taskbookService.getActionsByTaskType(this.task);
        }
    }

    action(task: Task, action: TaskAction){
        this.onAction.emit({ task: task, action: action })
    }

}
